import ElementLink, { ElementLinkPropTypes } from './ElementLink';

export { ElementLinkPropTypes };

export default ElementLink;
